namespace TabAurous.OMS {
    export interface OthersRow {
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        ProductTypeName?: string;
        ProductTypeId?: number;
        ItemTypeId?: number;
        HSN?: string;
        TaxCode?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        AttributeId?: number;
        Attribute?: string;
        Rate?: number;
        CalcOnId?: number;
        CalcUnitId?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace OthersRow {
        export const idProperty = 'ProductId';
        export const nameProperty = 'ProductCode';
        export const localTextPrefix = 'OMS.Others';
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            ProductTypeName = "ProductTypeName",
            ProductTypeId = "ProductTypeId",
            ItemTypeId = "ItemTypeId",
            HSN = "HSN",
            TaxCode = "TaxCode",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            Rate = "Rate",
            CalcOnId = "CalcOnId",
            CalcUnitId = "CalcUnitId",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
